import { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { fetchRecommendedVehiclesNew } from '@/ducks/recommendedVehiclesNew'

const useFetchRecommendedVehicles = (idAdvertise, idCampaign) => {
  const dispatch = useDispatch()
  const { result, isLoading } = useSelector(
    state => state.recommendedVehiclesNewState
  )

  useEffect(() => {
    if (!idAdvertise) return

    const params = {
      idAdvertiser: idAdvertise,
      idCampaign,
      displayPerPage: 12,
    }

    dispatch(fetchRecommendedVehiclesNew(params))
  }, [dispatch, idAdvertise])

  const recommendations = useMemo(() => {
    if (
      !result ||
      !result.success ||
      !Array.isArray(result.recommendations) ||
      result.recommendations.length === 0
    ) {
      return []
    }

    return result.recommendations.slice(0, 12)
  }, [result])

  return {
    result: recommendations,
    isLoading,
  }
}

export default useFetchRecommendedVehicles